export { GenericSearch, type GenericSearchProps } from "./GenericSearch";
